import React from "react";
import { NEUT_BG, LINE } from "../../Bureau/bureauTokens";

// Squelette d'une ligne de ThreadList — mêmes proportions que ThreadListItem
// (avatar + nom/heure + aperçu) pour ne pas décaler la mise en page une fois
// les conversations arrivées.
function ThreadListItemSkeleton() {
  return (
    <div className="flex items-center gap-2.5 px-3 py-2.5 animate-pulse" style={{ borderBottom: `1px solid ${LINE}` }}>
      <span className="flex-shrink-0 rounded-full" style={{ width: 38, height: 38, background: NEUT_BG }} />
      <span className="flex-1 min-w-0 flex flex-col gap-1.5">
        <span className="flex items-center justify-between gap-2">
          <span className="h-2.5 rounded" style={{ width: 100, background: NEUT_BG }} />
          <span className="h-2 rounded flex-shrink-0" style={{ width: 24, background: NEUT_BG }} />
        </span>
        <span className="h-2.5 rounded" style={{ width: "75%", background: NEUT_BG }} />
      </span>
    </div>
  );
}

export default ThreadListItemSkeleton;
